import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import Container from '@mui/material/Container';
import ButtonBase from '@mui/material/ButtonBase';
import { useLocation, useHistory } from 'react-router-dom';
import { flow } from 'lodash';
import { useSelector } from 'react-redux';

import usePdvAccess from '@giro-pdv/hooks/usePdvAccess.hook';
import useAuthHook from '@giro/shared-hooks/useAuth.hook';
import useIsTotemHook from '@giro-pdv/hooks/useTotem.hook';

import Logo from '@giro/shared-components/Logo.component';

import ROUTES, { NAMESPACES } from '@giro-pdv/constants/routes.constant';
import segmentNormalizeConstant from '@giro-pdv/constants/segmentNormalize.constant';

import clients from '@giro-pdv/modules/pdv/store/clients';
import useGtappMenuAccess from '@giro-pdv/hooks/useGtappMenuAccess.hook';
import sync from '@giro-pdv/modules/pdv/store/sync';

const menuSidebarConstant = [
  {
    label: 'DETRANs',
    route: ROUTES.PDV.DETRAN,
    segment: segmentNormalizeConstant.DETRAN,
    icon: (
      <svg
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <use href="/feather-sprite.svg#shield" />
      </svg>
    ),
  },
  {
    label: 'Totem',
    route: ROUTES.PDV.TOTEM,
    segment: segmentNormalizeConstant.TOTEM,
    icon: (
      <svg
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <use href="/feather-sprite.svg#monitor" />
      </svg>
    ),
  },
  {
    label: 'Boletos',
    route: ROUTES.PDV.BILLET,
    segment: segmentNormalizeConstant.BOLETO,
    icon: (
      <svg
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <use href="/feather-sprite.svg#align-justify" />
      </svg>
    ),
  },
  {
    label: 'Link de pagamento',
    route: ROUTES.PAYMENT_LINKS.ROOT,
    segment: segmentNormalizeConstant.LINK_VAREJO,
    icon: (
      <svg
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <use href="/feather-sprite.svg#link" />
      </svg>
    ),
  },
  {
    label: 'Gerar Boletos',
    route: ROUTES.SLIPS.ROOT,
    segment: segmentNormalizeConstant.GERENCIAR_BOLETOS,
    icon: (
      <svg
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <use href="/feather-sprite.svg#file-plus" />
      </svg>
    ),
  },
  {
    label: 'Rel. Boletos',
    route: ROUTES.REPORTS.SLIPS,
    segment: segmentNormalizeConstant.GERENCIAR_BOLETOS,
    icon: (
      <svg
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <use href="/feather-sprite.svg#file-plus" />
      </svg>
    ),
  },
  {
    label: 'Financiamento',
    route: ROUTES.PDV.FINANCING,
    segment: segmentNormalizeConstant.FINANCIAMENTO,
    icon: (
      <svg
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <use href="/feather-sprite.svg#divide" />
      </svg>
    ),
  },
  {
    label: 'Monitoramento',
    route: ROUTES.MONITORING.ROOT,
    segment: segmentNormalizeConstant.MONITORING,
    icon: (
      <svg
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <use href="/feather-sprite.svg#monitor" />
      </svg>
    ),
  },
  // {
  //   label: 'PIX',
  //   module: NAMESPACES.PDV.substring(1),
  //   route: ROUTES.PDV.ROOT,
  //   icon: (
  //     <svg
  //       width="16"
  //       height="16"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //     >
  //       <use href="/feather-sprite.svg#dollar-sign" />
  //     </svg>
  //   ),
  // },
  // {
  //   label: 'Seguros',
  //   module: NAMESPACES.PDV.substring(1),
  //   route: ROUTES.PDV.ROOT,
  //   icon: (
  //     <svg
  //       width="16"
  //       height="16"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //     >
  //       <use href="/feather-sprite.svg#dollar-sign" />
  //     </svg>
  //   ),
  // },
  // {
  //   label: 'Crédito',
  //   module: NAMESPACES.PDV.substring(1),
  //   route: ROUTES.PDV.ROOT,
  //   icon: (
  //     <svg
  //       width="16"
  //       height="16"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //     >
  //       <use href="/feather-sprite.svg#dollar-sign" />
  //     </svg>
  //   ),
  // },
  // {
  //   label: 'Agenda de recebíveis',
  //   module: NAMESPACES.PDV.substring(1),
  //   route: ROUTES.PDV.ROOT,
  //   icon: (
  //     <svg
  //       width="16"
  //       height="16"
  //       fill="none"
  //       stroke="currentColor"
  //       strokeWidth="2"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //     >
  //       <use href="/feather-sprite.svg#dollar-sign" />
  //     </svg>
  //   ),
  // },
  {
    label: 'Recarga de celular',
    route: ROUTES.PDV.RECHARGE,
    segment: segmentNormalizeConstant.RECHARGE,
    icon: (
      <svg
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <use href="/feather-sprite.svg#smartphone" />
      </svg>
    ),
  },
];

const menu = ({
  isTotem,
  isCrea,
  canAccessPdv,
  canAccessEcReports,
  menuSub,
  pathname,
  segment,
  canAccessTerminals,
}) =>
  [
    !isTotem &&
      canAccessPdv && {
        label: 'PDV',
        module:
          !menuSub.some((ms) => ms.route === pathname) &&
          NAMESPACES.PDV.substring(1),
        route: ROUTES.PDV.ROOT,
        icon: (
          <svg
            width="16"
            height="16"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <use href="/feather-sprite.svg#grid" />
          </svg>
        ),
      },
    !isTotem && {
      label: 'Relatórios',
      module: NAMESPACES.REPORTS.substring(1),
      route: ROUTES.REPORTS.ROOT,
      icon: (
        <svg
          width="16"
          height="16"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <use href="/feather-sprite.svg#clipboard" />
        </svg>
      ),
      submenu: [
        canAccessEcReports && {
          label: 'EC',
          route: ROUTES.REPORTS.EC,
          icon: (
            <svg
              width="16"
              height="16"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <use href="/feather-sprite.svg#clipboard" />
            </svg>
          ),
        },
        canAccessEcReports &&
          segment?.includes(segmentNormalizeConstant.FINANCIAMENTO) && {
            label: 'Financiamento',
            route: ROUTES.REPORTS.FINANCING,
            icon: (
              <svg
                width="16"
                height="16"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <use href="/feather-sprite.svg#clipboard" />
              </svg>
            ),
          },
        isCrea && {
          label: 'Crea',
          route: ROUTES.REPORTS.CREA,
          icon: (
            <svg
              width="16"
              height="16"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <use href="/feather-sprite.svg#clipboard" />
            </svg>
          ),
        },
      ].filter(Boolean),
    },
    !isTotem &&
      isCrea &&
      canAccessEcReports && {
        label: 'Relatório CREA',
        route: ROUTES.REPORTS.CREA,
        icon: (
          <svg
            width="16"
            height="16"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <use href="/feather-sprite.svg#file-text" />
          </svg>
        ),
      },
    canAccessTerminals && {
      label: 'Tap on Phone',
      module: NAMESPACES.TERMINALS.substring(1),
      route: ROUTES.TERMINALS.ROOT,
      icon: (
        <svg
          width="16"
          height="16"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <use href="/feather-sprite.svg#tablet" />
        </svg>
      ),
    },
  ].filter(Boolean);

const menuPDV = (segment) => [
  {
    label: 'Cartório',
    route: ROUTES.PDV.CARTORIO,
    visible: segment.includes(segmentNormalizeConstant.CARTORIO),
    icon: (
      <svg
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <use href="/feather-sprite.svg#home" />
      </svg>
    ),
  },
  {
    label: 'Sobre',
    module: NAMESPACES.PDV.substring(1),
    visible: segment.includes(segmentNormalizeConstant.CARTORIO),
    route: ROUTES.PDV.ABOUT,
    icon: (
      <svg
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <use href="/feather-sprite.svg#info" />
      </svg>
    ),
  },
  {
    label: 'Despachante',
    route: ROUTES.PDV.AGENT,
    visible: segment.includes(segmentNormalizeConstant.DESPACHANTE),
    icon: (
      <svg
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <use href="/feather-sprite.svg#file-text" />
      </svg>
    ),
  },
  {
    label: 'Veículo',
    route: ROUTES.PDV.VEHICLE,
    visible: segment.includes(segmentNormalizeConstant.VEICULOS),
    icon: (
      <svg
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <use href="/feather-sprite.svg#truck" />
      </svg>
    ),
  },
  {
    label: 'Geral',
    route: ROUTES.PDV.GERAL,
    visible:
      segment.includes(segmentNormalizeConstant.GERAL) ||
      segment.includes(segmentNormalizeConstant.COOPNORE),
    icon: (
      <svg
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <use href="/feather-sprite.svg#sidebar" />
      </svg>
    ),
  },
  {
    label: 'Educação',
    route: ROUTES.PDV.EDUCACAO,
    visible: segment.includes(segmentNormalizeConstant.EDUCACAO),
    icon: (
      <svg
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <use href="/feather-sprite.svg#book-open" />
      </svg>
    ),
  },
  {
    label: 'Pátio',
    route: ROUTES.PDV.VEHICLE,
    visible: segment.includes(segmentNormalizeConstant.PATIO),
    icon: (
      <svg
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <use href="/feather-sprite.svg#truck" />
      </svg>
    ),
  },
  {
    label: 'Assessoria',
    route: ROUTES.PDV.ASSESSORIA,
    visible: segment.includes(segmentNormalizeConstant.ACESSORIA),
    icon: (
      <svg
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <use href="/feather-sprite.svg#hash" />
      </svg>
    ),
  },
  {
    label: 'Cemitério',
    route: ROUTES.PDV.CEMITERIO,
    visible: segment.includes(segmentNormalizeConstant.CEMITERIO),
    icon: (
      <svg
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <use href="/feather-sprite.svg#award" />
      </svg>
    ),
  },
];

const menuReports = ({ isCrea, canAccessEcReports, segment }) => [
  {
    label: 'EC',
    route: ROUTES.REPORTS.EC,
    visible: canAccessEcReports,
    icon: (
      <svg
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <use href="/feather-sprite.svg#file-text" />
      </svg>
    ),
  },
  {
    label: 'Financiamento',
    route: ROUTES.REPORTS.FINANCING,
    visible:
      canAccessEcReports &&
      segment?.includes(segmentNormalizeConstant.FINANCIAMENTO),
    icon: (
      <svg
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <use href="/feather-sprite.svg#file-text" />
      </svg>
    ),
  },
  {
    label: 'Crea',
    route: ROUTES.REPORTS.CREA,
    visible: isCrea,
    icon: (
      <svg
        width="16"
        height="16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <use href="/feather-sprite.svg#file-text" />
      </svg>
    ),
  },
];

const HeaderComponent = ({ handleToggleSide = () => {}, sideOpen }) => {
  const [menuCurrentRender, setMenuCurrentRender] = React.useState('primary');

  const { user } = useAuthHook();
  const { pathname } = useLocation();
  const {
    isCrea,
    segments,
    canAccessPdv,
    canAccessEcReports,
    usesCartorioBilling,
  } = usePdvAccess();
  const isTotem = useIsTotemHook();
  const history = useHistory();

  const selectorClientsPdv = useSelector(clients.selector.selectState);
  const selectorSyncPdv = useSelector(sync.selector.selectState);

  const isSubPdv = menuSidebarConstant.map((ms) => ms.route).includes(pathname);
  const currentModule = isSubPdv ? 'default' : pathname.split('/')[1];
  const menuToRender = {
    default: flow(() => {}),
    pdv: flow(() => segments, menuPDV),
    reports: flow(
      () => ({ isCrea, canAccessEcReports, segment: segments }),
      menuReports
    ),
  };
  const menuSecondary =
    (menuToRender[currentModule] || menuToRender.default)() || [];
  const menuSecondaryVisible = menuSecondary?.filter(
    (e) => e.visible && !(usesCartorioBilling && e.route === ROUTES.PDV.ABOUT)
  );
  const menuPrimaryConcat = menuSidebarConstant.filter((el) =>
    segments.includes(el.segment)
  );
  const canAccessTerminals = useGtappMenuAccess(selectorClientsPdv?.payload);
  const menuPrimary = menu({
    isTotem,
    isCrea,
    canAccessPdv,
    canAccessEcReports,
    menuSub: menuPrimaryConcat,
    pathname,
    segment: segments,
    canAccessTerminals,
  }).concat(menuPrimaryConcat as any);

  const menuRender =
    menuCurrentRender === 'primary' ? menuPrimary : menuSecondaryVisible;

  const isMenuActive = (menuItem: any) => {
    const route = menuItem?.route;

    if (!route) {
      return false;
    }

    const hasMoreSpecificActiveItem = menuRender?.some(
      (item: any) =>
        item.route.startsWith(`${route}/`) &&
        (pathname === item.route || pathname.startsWith(`${item.route}/`))
    );

    if (pathname === route) {
      return true;
    }

    if (route === ROUTES.PDV.ROOT && pathname.startsWith(`${route}/`)) {
      return !hasMoreSpecificActiveItem;
    }

    if (route !== ROUTES.PDV.ROOT && pathname.startsWith(`${route}/`)) {
      return !hasMoreSpecificActiveItem;
    }

    return Boolean(
      route === ROUTES.PDV.ROOT &&
        menuItem.module &&
        pathname.split('/')[1] === menuItem.module
    );
  };

  const syncCodeTooltip = (
    <Box display="flex" flexDirection="column">
      <Typography align="center" variant="trasso_button" fontWeight={500}>
        Código de sincronização
      </Typography>

      <Box display="flex" alignItems="center" justifyContent="center">
        <Typography>
          <strong>{selectorSyncPdv?.payload?.linkedkey}</strong>
        </Typography>
      </Box>
    </Box>
  );

  const nameHtml = (
    <Box
      display="inline-flex"
      alignItems="center"
      justifyContent={{ xs: 'center', md: 'flex-end' }}
      gap={0.75}
      maxWidth="100%"
      sx={{
        color: 'white',
        minHeight: 28,
        px: { xs: 1, md: 0 },
      }}
    >
      <Typography
        color="inherit"
        align="right"
        variant="subtitle1"
        noWrap
        sx={{
          maxWidth: { xs: 'min(70vw, 280px)', md: 240 },
          fontSize: { xs: '13px', md: '14px' },
          lineHeight: '20px',
          fontWeight: 600,
          letterSpacing: 0,
        }}
      >
        {user?.user?.name}
      </Typography>
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ flexShrink: 0 }}
      >
        <use href="/feather-sprite.svg#chevron-down" />
      </svg>
    </Box>
  );

  return (
    <Box
      className="header-container"
      display="flex"
      flexDirection="column"
      bgcolor="trasso.gray.20"
    >
      <Box
        sx={{
          position: 'relative',
          overflow: 'hidden',
          height: { xs: 118, md: 98 },
          bgcolor: '#360067',
          background:
            'radial-gradient(circle at 100% 10%, rgba(215, 118, 255, 0.28) 0, rgba(215, 118, 255, 0.17) 16%, transparent 34%), radial-gradient(circle at 0% 100%, rgba(129, 0, 189, 0.75) 0, rgba(129, 0, 189, 0.32) 30%, transparent 48%), linear-gradient(105deg, #240045 0%, #360067 54%, #4b008f 100%)',
          boxShadow: '0 4px 18px rgba(36, 0, 69, 0.22)',
          '&::after': {
            content: '""',
            position: 'absolute',
            right: { xs: '-80px', md: '0' },
            bottom: '-62px',
            width: { xs: 220, md: 286 },
            height: { xs: 140, md: 172 },
            borderRadius: '50%',
            background: 'rgba(215, 118, 255, 0.13)',
          },
        }}
      >
        <Container
          maxWidth={false}
          sx={{
            position: 'relative',
            zIndex: 1,
            height: '100%',
            maxWidth: 1780,
            px: { xs: 2, md: 6, lg: 8 },
          }}
        >
          <Box
            display="grid"
            gridTemplateColumns={{
              xs: '1fr',
              md: '1fr minmax(200px, 1fr) 1fr',
            }}
            alignItems="center"
            minHeight="100%"
            rowGap={1.5}
            py={{ xs: 2, md: 0 }}
          >
            <Box
              display="flex"
              alignItems="center"
              gap={2}
              width="100%"
              justifyContent={{ xs: 'center', md: 'flex-start' }}
              minWidth={0}
            >
              <Logo
                variant="pdv"
                style={{
                  display: 'block',
                  width: 'clamp(112px, 12vw, 124px)',
                  height: 'auto',
                }}
              />
            </Box>
            <Typography
              align="center"
              variant="header_sm"
              noWrap
              sx={{
                color: '#E8BCFF',
                fontSize: { xs: '16px', md: '17px' },
                lineHeight: { xs: '22px', md: '24px' },
                fontWeight: 500,
                letterSpacing: 0,
                px: { xs: 2, md: 1 },
              }}
            >
              {selectorClientsPdv?.payload?.nmFantasia}
            </Typography>
            <Box
              display="flex"
              justifyContent={{ xs: 'center', md: 'flex-end' }}
              minWidth={0}
              width="100%"
            >
              {!selectorSyncPdv?.payload?.linkedkey && nameHtml}

              {selectorSyncPdv?.payload?.linkedkey && (
                <Tooltip arrow title={syncCodeTooltip}>
                  {nameHtml}
                </Tooltip>
              )}
            </Box>
          </Box>
        </Container>
      </Box>
      <Box
        sx={{
          mt: { xs: '-30px', md: '-26px' },
          pb: { xs: 1.5, md: 2.25 },
          position: 'relative',
          zIndex: 2,
        }}
      >
        <Container
          maxWidth={false}
          disableGutters
          sx={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            px: { xs: 1.5, md: 3 },
          }}
        >
          <Box
            component="nav"
            aria-label="Menu principal"
            display="flex"
            alignItems="center"
            sx={{
              minHeight: { xs: 52, md: 50 },
              width: { xs: '100%', md: 'max-content' },
              maxWidth: '100%',
              overflowX: 'auto',
              overflowY: 'hidden',
              gap: { xs: 0.5, sm: 0 },
              px: { xs: 1, sm: 1.25 },
              py: { xs: 0.75, md: 0.75 },
              borderRadius: { xs: '28px', md: '999px' },
              bgcolor: 'white',
              border: '1px solid rgba(54, 0, 103, 0.08)',
              boxShadow: '0 10px 24px rgba(36, 0, 69, 0.18)',
              scrollbarWidth: 'none',
              '&::-webkit-scrollbar': {
                display: 'none',
              },
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              minWidth={{ xs: 'max-content', md: 0 }}
            >
              {menuRender?.map((m: any, i) => (
                <React.Fragment key={`idx-${i}`}>
                  <ButtonBase
                    aria-current={isMenuActive(m) ? 'page' : undefined}
                    onClick={() => {
                      history.push(m.route);
                    }}
                    sx={{
                      flex: '0 0 auto',
                      height: { xs: 38, md: 38 },
                      minWidth: {
                        xs: 'max-content',
                        sm: m?.label?.length > 12 ? 146 : 112,
                        md: m?.label?.length > 12 ? 150 : 112,
                      },
                      px: { xs: 1.75, md: 2.25 },
                      borderRadius: '999px',
                      color: isMenuActive(m) ? 'white' : 'trasso.purple.60',
                      background: isMenuActive(m)
                        ? 'linear-gradient(180deg, #C757FF 0%, #8100BD 100%)'
                        : 'transparent',
                      boxShadow: isMenuActive(m)
                        ? '0 8px 16px rgba(129, 0, 189, 0.28)'
                        : 'none',
                      transition:
                        'background-color 160ms ease, box-shadow 160ms ease, color 160ms ease',
                      '&:hover': {
                        bgcolor: isMenuActive(m)
                          ? undefined
                          : 'rgba(129, 0, 189, 0.08)',
                      },
                      '& svg': {
                        width: 18,
                        height: 18,
                        color: 'currentColor',
                      },
                    }}
                  >
                    <Box
                      display="flex"
                      alignItems="center"
                      gap={1}
                      minWidth={0}
                    >
                      {m?.icon}
                      <Typography
                        color="inherit"
                        variant="trasso_heading_extra_small"
                        noWrap
                        sx={{
                          fontSize: { xs: '11px', md: '12px' },
                          lineHeight: '16px',
                          fontWeight: 600,
                          letterSpacing: 0,
                        }}
                      >
                        {m?.label}
                      </Typography>
                    </Box>
                  </ButtonBase>

                  {i < menuRender.length - 1 && (
                    <Box
                      aria-hidden
                      sx={{
                        display: { xs: 'none', sm: 'block' },
                        flex: '0 0 auto',
                        width: '1px',
                        height: 24,
                        mx: { sm: 0.5, md: 0.75 },
                        bgcolor: 'rgba(54, 0, 103, 0.12)',
                      }}
                    />
                  )}
                </React.Fragment>
              ))}
            </Box>

            {menuCurrentRender !== 'primary' && (
              <Box flex="0 0 auto" ml={1}>
                <Button
                  variant="outlined"
                  sx={{
                    borderRadius: '999px',
                    borderColor: 'trasso.gray.40',
                    color: 'trasso.purple.60',
                    height: 40,
                  }}
                  onClick={() => {
                    setMenuCurrentRender('primary');
                  }}
                >
                  Voltar
                </Button>
              </Box>
            )}
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default HeaderComponent;
